import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function loadToken() {
  return sessionStorage.getItem('accaAdminToken') || ''
}

export default new Vuex.Store({
  state: {
    token: loadToken(),
    userInfo: null
  },
  mutations: {
    setToken(state, token) {
      state.token = token || ''
      if (token) {
        sessionStorage.setItem('accaAdminToken', token)
      } else {
        sessionStorage.removeItem('accaAdminToken')
      }
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    clearAuth(state) {
      state.token = ''
      state.userInfo = null
      sessionStorage.removeItem('accaAdminToken')
    }
  }
})
